/* eslint-disable import/prefer-default-export */
import { TServiceMap } from '@features/categories/typescript';
import { TLocale } from '@typescript/index';
export const getServiceMap = async (locale: TLocale): Promise<TServiceMap | null> => {
  try {
    const response = await fetch(`/api/${locale}/servicemap`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return Object.keys(data).length > 0 ? data : null;
  } catch (error) {
    console.error('Error processing service map\n', error);
    return null;
  }
};